import { createStandardAction } from "typesafe-actions";

export const saveCompaniesCnpj = createStandardAction("@@utils/SAVE_COMPANIES_CNPJ")();
export const saveGovernmentAgenciesCnpj = createStandardAction("@@utils/SAVE_GOVERNMENT_AGENCIES_CNPJ")();
export const clearCnpjList = createStandardAction("@@utils/CLEAR_CNPJ_LIST")();
export const saveBrandsNames = createStandardAction("@@utils/SAVE_BRANDS_NAMES")();
export const clearBrandsNames = createStandardAction("@@utils/CLEAR_BRANDS_NAMES")();
export const saveUnitiesOfMeasurement = createStandardAction("@@utils/SAVE_UNITIES_OF_MEASUREMENT")();
export const clearUnitiesOfMeasurement = createStandardAction("@@utils/CLEAR_UNITIES_OF_MEASUREMENT")();
export const saveProductFamily = createStandardAction("@@utils/SAVE_PRODUCT_FAMILY")();